module.exports = __webpack_public_path__ + "static/2-Eye-level-Day-View-c7b60af66bab8a2c1ab2543fe34f2595.jpg";